import { AuctionPenPenRangeFilterConf } from "./Filters/AuctionPenPenRange";
import { MlaPenRangeFilterConf } from "./Filters/MlaPenPenRange";
import { FilterConf } from "./types";

export const AuctionPenFilterIds: string[] = [AuctionPenPenRangeFilterConf.id];

export const MlaSupplementaryDataFilterIds: string[] = [
  MlaPenRangeFilterConf.id,
];

export const FilterFormMap: { [key: string]: FilterConf } = {
  [AuctionPenPenRangeFilterConf.id]: AuctionPenPenRangeFilterConf,
  [MlaPenRangeFilterConf.id]: MlaPenRangeFilterConf,
};

export function getFilterConf(filterId: string): FilterConf | null {
  return FilterFormMap[filterId] || null;
}
